module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-core-image-upload-btn"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImage),
      expression: "!hasImage"
    }],
    staticClass: "g-core-image-upload-form",
    staticStyle: {
      "display": "block",
      "cursor": "pointer",
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "1242px",
      "height": "61px",
      "opacity": "0",
      "margin": "0px",
      "padding": "0px",
      "overflow": "hidden"
    },
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api2/common_user/cropHeadUrl"
    }
  }, [_c('input', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "disabled": _vm.uploading,
      "id": 'g-core-upload-input-' + _vm.formID,
      "name": _vm.name,
      "multiple": _vm.multiple,
      "type": "file",
      "accept": _vm.inputAccept
    },
    on: {
      "change": _vm.change
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImage),
      expression: "hasImage"
    }],
    staticClass: "g-core-image-corp-container",
    attrs: {
      "id": 'vciu-modal-' + _vm.formID
    }
  }, [_c('crop', {
    ref: "cropBox",
    attrs: {
      "is-resize": _vm.resize && !_vm.crop,
      "ratio": _vm.cropRatio
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-aside"
  }, [(_vm.crop) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doCrop
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cropBtn.cancel))])]) : _vm._e(), _vm._v(" "), (_vm.resize) ? _c('p', {
    staticClass: "btn-groups"
  }, [_c('button', {
    staticClass: "btn btn-upload",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doResize
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.ok))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.ResizeBtn.cancel))])]) : _vm._e()])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c2fa9ea"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-core-image-upload/dist/vue-core-image-upload.vue
// module id = 513
// module chunks = 4